<template>
    <div id="app">
        <header class="header" v-if="getCurrentUser">
            <!-- v-if="getCurrentUser" if logged in view only -->
            <nav id="nav" class="nav">
                <!--<RouterLink to="/categories">Categories</RouterLink>-->
                <!--<RouterLink to="/account">Account</RouterLink>-->
                <div style="display: inline-block">
                    Hi {{ getUserProfile.name }},
                    <button @click="logout">Logout</button>
                </div>
                <RouterLink :to="{ name: 'addNew' }" class="button button--add-recipe">Add A Recipe</RouterLink>
            </nav>
            <RouterLink to="/" class="logo-link">
                <div class="logo">
                    FORK
                    <br />YOU
                </div>
            </RouterLink>
        </header>
        <RouterView />
    </div>
</template>

<script>
import { mapGetters } from "vuex";
const fb = require("../firebaseConfig.js");
export default {
    created() {
        console.log("created app.vue");
        this.$store.dispatch("initRecipes");
        /*
        const self = this;
        promise.then(function() {
            self.isLoading = false;
        });*/
        /*        if (this.currentUser) {
            let promise = this.$store.dispatch("initRecipes");
            const self = this;

            promise.then(() => {
                self.$router.push("/");
            });
        }*/
    },
    computed: {
        ...mapGetters(["getCurrentUser", "getUserProfile"])
    },
    methods: {
        logout() {
            console.log(this.getCurrentUser);
            fb.auth
                .signOut()
                .then(() => {
                    this.$store.dispatch("clearUserData");
                    //this.$store.dispatch("clearRecipeData");
                    this.$router.push("/login");
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }
};
</script>

<style lang="scss">
@import "./styles/global.scss";
</style>